import { Navigate, Route } from 'react-router-dom';
import { WardrobeRouteSegments, WardrobePaths } from '@/shared/routePaths';
import { renderRouteLeaves } from '@/shared/utils/routeUtils';
import { WardrobePage } from './pages';
import { wardrobeChildRouteConfig } from './config';

/** Must be a `<Route>` element (not a wrapper component): RR only accepts `<Route>` as nested route children. */
export const wardrobeRoutesBranch = (
  <Route path={WardrobePaths.root} element={<WardrobePage />}>
    <Route
      index
      element={<Navigate to={WardrobeRouteSegments.indexRedirect} replace />}
    />
    {renderRouteLeaves(wardrobeChildRouteConfig)}
  </Route>
);
